import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { fontWeights } from 'shared/style/fonts'
import colors from 'shared/style/colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('md')]: {
        textAlign: 'left',
        maxWidth: '20rem',
        margin: 'auto !important'
      },
      padding: '2rem 0'
    },
    wrapper: {
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column'
      }
    },
    footerMenuColumn: {
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        justifyContent: 'flex-start',
        textAlign: 'left'
      }
    },
    footerMenuColumnImage: {
      width: '35%',
      [theme.breakpoints.down('md')]: {
        width: '30%'
      }
    },
    title: {
      fontFamily: 'Montserrat'
    },
    link: {
      display: 'inline-block',
      '&:hover': {
        fontWeight: fontWeights.bold,
        color: colors.black
      }
    }
  })
)
